module.exports = __webpack_public_path__ + "images/emoji/disappointed.a1c9120342a31a48e6b7.png";